<template>
  <div class="contacts">
    <h1>Что делать если появились симптомы</h1>
    <div class="container">
      <div class="contacts-elements">
        <div class="contacts-element">
          <div class="contacts-element-icon"><Contacts1/></div>
          <span class="contacts-element-text">Самоизолироваться</span>
        </div>
        <div class="contacts-element">
          <div class="contacts-element-icon"><Contacts2/></div>
          <span class="contacts-element-text">Позвонить в скорую по телефону 103</span>
        </div>
      </div>
      <div class="contacts-info">
        <span class="contacts-info__title">Телефоны горячей линии:</span>
        <span class="contacts-info__text">+7 (800) 2000-112  Единая горячая линия сайта стопкоронавирус.рф</span>
        <span class="contacts-info__text">+7 (800) 555-4943 Горячая линия Роспотребнадзора</span>
      </div>
    </div>
  </div>
</template>

<script>
import Contacts1 from '@/assets/svg/infographics/contacts1.svg';
import Contacts2 from '@/assets/svg/infographics/contacts2.svg';

export default {
  components: {
    Contacts1,
    Contacts2
  }
}
</script>

<style lang="scss" scoped>
.contacts {
  padding: 60px 0;
  & .container {
    max-width: 790px;
  }
  &-info {
    margin-top: 30px;
    text-align: center;
    &__title {
      display: block;
      font-weight: bold;
      font-size: 20px;
    }
    &__text {
      display: block;
    }
  }
  &-elements {
    display: flex;
    justify-content: space-between;
    margin-top: 105px;
  }
  &-element {
    max-width: 385px;
    min-width: 385px;
    border: 2px dashed #d1e2ea;
    border-radius: 5px;
    padding: 25px;
    padding-top: 93px;
    height: 142px;
    position: relative;
    color: #000;
    font-size: 15px;
    &-icon {
      border-radius: 50%;
      width: 146px;
      height: 146px;
      left: 50%;
      margin-left: -73px;
      top: -73px;
      position: absolute;
      box-shadow: 0 3px 5px rgba(194, 213, 225, 0.99);
    }
    &-text {
      display: block;
      text-align: center;
      font-size: 15px;
    }
  }
}

@media screen and (max-width: 767px) {
  .contacts {
    padding: 50px 0;
    &-elements {
      flex-wrap: wrap;
    }
    &-element {
      max-width: 80%;
      min-width: 80%;
      margin: 0 auto;
      margin-bottom: 105px;
      height: 160px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    &-info {
      &__title {
        margin-bottom: 20px;
      }
      &__text {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>